var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.conexaoCta && _vm.conexaoCta.type
    ? _c(
        "div",
        {
          staticClass:
            "chat-window__empty d-flex flex-column align-center justify-center flex-grow-1 px-6",
          attrs: { "data-test": "conexao-cta-empty" }
        },
        [
          _c("icon-svg", {
            staticClass: "mb-4",
            attrs: { name: _vm.icons.chatOutline, size: "64", color: "#8E8E8E" }
          }),
          _c(
            "span",
            {
              staticClass: "az-text-primary az-size-16 font-medium az-muted",
              attrs: { "data-test": "conexao-cta-title" }
            },
            [_vm._v(" " + _vm._s(_vm.conexaoCta.title) + " ")]
          ),
          _c(
            "span",
            {
              staticClass:
                "az-text-small text-center mt-1 chat-window__empty-hint",
              attrs: { "data-test": "conexao-cta-description" }
            },
            [_vm._v(" " + _vm._s(_vm.conexaoCta.description) + " ")]
          ),
          _vm.conexaoCta.type === _vm.ctaTypes.CONFIG
            ? _c(
                "router-link",
                {
                  staticClass: "az-text-small mt-4",
                  staticStyle: { color: "var(--primary)" },
                  attrs: {
                    to: { name: "settings-v2.atendimento.conexoes" },
                    "data-test": "conexao-cta-config-link"
                  }
                },
                [_vm._v(" Ir para Configurações ")]
              )
            : _vm.conexaoCta.type === _vm.ctaTypes.SCAN_QRCODE
            ? _c(
                "v-menu",
                {
                  attrs: {
                    "max-width": "640",
                    top: "",
                    "open-on-hover": "",
                    "close-on-content-click": false
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "span",
                              _vm._g(
                                {
                                  staticClass:
                                    "cursor-help d-inline-flex align-center az-text-small mt-3",
                                  staticStyle: { color: "var(--primary)" }
                                },
                                on
                              ),
                              [
                                _c("icon-svg", {
                                  staticClass: "mr-1",
                                  attrs: {
                                    name: "mdi-information",
                                    size: "14",
                                    color: "var(--primary)"
                                  }
                                }),
                                _vm._v(" Ver tutorial passo a passo ")
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    610032687
                  ),
                  model: {
                    value: _vm.tutorialMenuActive,
                    callback: function($$v) {
                      _vm.tutorialMenuActive = $$v
                    },
                    expression: "tutorialMenuActive"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "az-card pa-4" },
                    [
                      _c("span", { staticClass: "az-text-small" }, [
                        _vm._v(" Clique no menu de ações "),
                        _c("b", [_vm._v("⋮")]),
                        _vm._v(" no topo da lista de conversas e selecione "),
                        _c("b", [_vm._v("Conectar via QR Code")]),
                        _vm._v(
                          ". Um modal abrirá com o código para pareamento no WhatsApp. "
                        )
                      ]),
                      _c("v-divider", { staticClass: "my-3" }),
                      _c("ConexaoQrcodeAnimatedSvg")
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass:
            "chat-window__empty d-flex flex-column align-center justify-center flex-grow-1 px-6",
          attrs: { "data-test": "no-conversation-selected" }
        },
        [
          _c("icon-svg", {
            staticClass: "mb-4",
            attrs: { name: _vm.icons.chatOutline, size: "64", color: "#8E8E8E" }
          }),
          _c(
            "span",
            { staticClass: "az-text-primary az-size-16 font-medium az-muted" },
            [_vm._v(" Selecione ou inicie uma conversa ")]
          ),
          _vm._m(0),
          _c(
            "BaseButton",
            {
              staticClass: "mt-4",
              attrs: {
                primary: "",
                "min-width": "200px",
                disabled: !_vm.canSendMessage
              },
              on: { click: _vm.onStartNovaConversa }
            },
            [
              _vm._v(" + "),
              _c("span", { staticClass: "ml-1" }, [_vm._v("Nova Conversa")])
            ]
          )
        ],
        1
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "az-text-small text-center mt-1 chat-window__empty-hint" },
      [
        _vm._v(" Escolha uma das conversas ao lado, ou toque em "),
        _c("strong", [_vm._v('"Nova Conversa"')]),
        _vm._v(
          " no topo da lista para começar uma conversa com qualquer número. "
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }